import { render, staticRenderFns } from "./Nuevo-movimiento-caja.vue?vue&type=template&id=2a76e09b&scoped=true"
import script from "./Nuevo-movimiento-caja.vue?vue&type=script&lang=js"
export * from "./Nuevo-movimiento-caja.vue?vue&type=script&lang=js"
import style0 from "./Nuevo-movimiento-caja.vue?vue&type=style&index=0&id=2a76e09b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a76e09b",
  null
  
)

export default component.exports